var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main-content" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "card" }, [
        _c(
          "div",
          { staticClass: "card-body" },
          [
            _c(
              "tabs",
              {
                staticClass: "tabs-default",
                attrs: { options: { defaultTabHash: "compra" } }
              },
              [
                _c("tab", { attrs: { id: "compra", name: "Compra" } }, [
                  _c("div", { staticClass: "card-body" }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-lg-3" }, [
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c("label", [_vm._v("Fecha")]),
                            _vm._v(" "),
                            _c("datepicker", {
                              attrs: {
                                format: _vm.format,
                                "input-class": "form-control",
                                language: _vm.es
                              },
                              model: {
                                value: _vm.purchaseDate,
                                callback: function($$v) {
                                  _vm.purchaseDate = $$v
                                },
                                expression: "purchaseDate"
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-lg-3" },
                        [
                          _c("label", [_vm._v("Localidad")]),
                          _vm._v(" "),
                          _c("multi-select", {
                            attrs: {
                              options: _vm.places,
                              "allow-empty": false,
                              "show-labels": false,
                              searchable: true,
                              label: "name",
                              "track-by": "id",
                              placeholder: "Seleccione una localidad"
                            },
                            on: { input: _vm.resetPlace },
                            model: {
                              value: _vm.place,
                              callback: function($$v) {
                                _vm.place = $$v
                              },
                              expression: "place"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-lg-4" }, [
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c("label", [_vm._v("Proveedor")]),
                            _vm._v(" "),
                            _c(
                              "multi-select",
                              {
                                attrs: {
                                  options: _vm.providers,
                                  "allow-empty": false,
                                  "show-labels": false,
                                  searchable: true,
                                  label: "company",
                                  "track-by": "company",
                                  placeholder: "Seleccione un proveedor",
                                  "internal-search": false,
                                  loading: _vm.isLoadingProvider,
                                  "custom-label": _vm.nameWithNit
                                },
                                on: {
                                  "search-change": _vm.searchProviders,
                                  input: _vm.calculateHighLighted
                                },
                                model: {
                                  value: _vm.provider,
                                  callback: function($$v) {
                                    _vm.provider = $$v
                                  },
                                  expression: "provider"
                                }
                              },
                              [
                                _c("template", { slot: "beforeList" }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn-success btn-lg btn-block",
                                      on: { click: _vm.openModalProvider }
                                    },
                                    [
                                      _vm._v("Nuevo Proveedor "),
                                      _c("i", {
                                        staticClass: "icon-fa icon-fa-plus"
                                      })
                                    ]
                                  )
                                ])
                              ],
                              2
                            )
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-lg-2" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _c("label", [_vm._v("Crédito autorizado")]),
                          _vm._v(" "),
                          _c("input", {
                            staticClass: "form-control",
                            attrs: { type: "text", readonly: "true" },
                            domProps: {
                              value: _vm.mymoney(
                                typeof _vm.provider.credit_limit !== "undefined"
                                  ? _vm.provider.credit_limit
                                  : 0
                              )
                            }
                          })
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-lg-4" }, [
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c("label", [_vm._v("Documento")]),
                            _vm._v(" "),
                            _c("multi-select", {
                              attrs: {
                                options: _vm.documents,
                                "allow-empty": false,
                                "show-labels": false,
                                label: "name",
                                "track-by": "id",
                                placeholder: "Seleccione un documento",
                                loading: _vm.isLoadingDocuments
                              },
                              on: {
                                input: function($event) {
                                  return _vm.getCorrelative(_vm.document.name)
                                }
                              },
                              model: {
                                value: _vm.document,
                                callback: function($$v) {
                                  _vm.document = $$v
                                },
                                expression: "document"
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-lg-2" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _c("label", [_vm._v("Serie")]),
                          _vm._v(" "),
                          _c("div", { staticClass: "input-group" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.number",
                                  value: _vm.correlative,
                                  expression: "correlative",
                                  modifiers: { number: true }
                                }
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "number",
                                "aria-label": "Recipient's username",
                                "aria-describedby": "basic-addon2"
                              },
                              domProps: { value: _vm.correlative },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.correlative = _vm._n($event.target.value)
                                },
                                blur: function($event) {
                                  return _vm.$forceUpdate()
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "input-group-append" }, [
                              _c(
                                "button",
                                {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value: {
                                        content: "Obtener correlativo",
                                        classes: ["info"],
                                        targetClasses: ["it-has-a-tooltip"],
                                        offset: 30
                                      },
                                      expression:
                                        "{\n                                        content: 'Obtener correlativo',\n                                        classes: ['info'],\n                                        targetClasses: ['it-has-a-tooltip'],\n                                        offset: 30,\n                                        }"
                                    }
                                  ],
                                  staticClass: "btn btn-outline-primary",
                                  attrs: {
                                    disabled: _vm.isLoadingCorrelative,
                                    type: "button"
                                  },
                                  on: { click: _vm.getCorrelative }
                                },
                                [
                                  _c("i", {
                                    staticClass: "icon-fa icon-fa-undo"
                                  })
                                ]
                              )
                            ])
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-lg-6" }, [
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c("label", [_vm._v("Productos")]),
                            _vm._v(" "),
                            _c("multi-select", {
                              ref: "products",
                              attrs: {
                                options: _vm.products,
                                "allow-empty": false,
                                "show-labels": false,
                                searchable: true,
                                label: "nameProduct",
                                "track-by": "nameProduct",
                                placeholder: "Seleccione sus productos",
                                "internal-search": false,
                                loading: _vm.isLoadingProducts,
                                "custom-label": _vm.nameWithCode
                              },
                              on: {
                                "search-change": _vm.searchProducts,
                                close: _vm.addProduct
                              },
                              model: {
                                value: _vm.product,
                                callback: function($$v) {
                                  _vm.product = $$v
                                },
                                expression: "product"
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-lg-12" }, [
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c("label", [_vm._v("Productos")]),
                            _vm._v(" "),
                            _c(
                              "table-component",
                              {
                                attrs: {
                                  data: _vm.selectProducts,
                                  "table-class": "table",
                                  "show-filter": false
                                }
                              },
                              [
                                _c("table-column", {
                                  attrs: { show: "code", label: "Código" }
                                }),
                                _vm._v(" "),
                                _c("table-column", {
                                  attrs: {
                                    show: "nameProduct",
                                    label: "Producto"
                                  }
                                }),
                                _vm._v(" "),
                                _c("table-column", {
                                  attrs: { show: "stock", label: "Existencia" },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "default",
                                      fn: function(row) {
                                        return [
                                          _vm._v(
                                            "\n                                                " +
                                              _vm._s(
                                                _vm.myquantity(row["stock"])
                                              ) +
                                              "\n                                            "
                                          )
                                        ]
                                      }
                                    }
                                  ])
                                }),
                                _vm._v(" "),
                                _c("table-column", {
                                  attrs: {
                                    sortable: false,
                                    filterable: false,
                                    show: "purchase_price",
                                    label: "Precio"
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "default",
                                      fn: function(row) {
                                        return [
                                          _vm._v(
                                            "\n                                                " +
                                              _vm._s(
                                                _vm.mymoney(
                                                  row["purchase_price"]
                                                )
                                              ) +
                                              "\n                                            "
                                          )
                                        ]
                                      }
                                    }
                                  ])
                                }),
                                _vm._v(" "),
                                _c("table-column", {
                                  attrs: {
                                    sortable: false,
                                    filterable: false,
                                    label: "Cantidad"
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "default",
                                      fn: function(row) {
                                        return [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model.number",
                                                value:
                                                  _vm.selectProducts[
                                                    _vm.getIndex(
                                                      _vm.selectProducts,
                                                      row["id"]
                                                    )
                                                  ].quantity,
                                                expression:
                                                  "selectProducts[getIndex(selectProducts,row['id'])].quantity",
                                                modifiers: { number: true }
                                              }
                                            ],
                                            ref:
                                              "quantity-" +
                                              _vm.getIndex(
                                                _vm.selectProducts,
                                                row["id"]
                                              ),
                                            staticClass: "form-control",
                                            class: {
                                              "is-invalid":
                                                _vm.selectProducts[
                                                  _vm.getIndex(
                                                    _vm.selectProducts,
                                                    row["id"]
                                                  )
                                                ].error === true
                                            },
                                            attrs: { type: "number" },
                                            domProps: {
                                              value:
                                                _vm.selectProducts[
                                                  _vm.getIndex(
                                                    _vm.selectProducts,
                                                    row["id"]
                                                  )
                                                ].quantity
                                            },
                                            on: {
                                              blur: [
                                                function($event) {
                                                  _vm.validateQuantity(
                                                    _vm.getIndex(
                                                      _vm.selectProducts,
                                                      row["id"]
                                                    )
                                                  )
                                                },
                                                function($event) {
                                                  return _vm.$forceUpdate()
                                                }
                                              ],
                                              keyup: function($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key,
                                                    "Enter"
                                                  )
                                                ) {
                                                  return null
                                                }
                                                _vm.refMultiple(
                                                  "quantity",
                                                  _vm.getIndexPlus(
                                                    _vm.selectProducts,
                                                    row["id"]
                                                  )
                                                )
                                              },
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  _vm.selectProducts[
                                                    _vm.getIndex(
                                                      _vm.selectProducts,
                                                      row["id"]
                                                    )
                                                  ],
                                                  "quantity",
                                                  _vm._n($event.target.value)
                                                )
                                              }
                                            }
                                          })
                                        ]
                                      }
                                    }
                                  ])
                                }),
                                _vm._v(" "),
                                _c("table-column", {
                                  attrs: {
                                    sortable: false,
                                    filterable: false,
                                    label: "Subtotal"
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "default",
                                      fn: function(row) {
                                        return [
                                          _vm._v(
                                            "\n                                                " +
                                              _vm._s(
                                                _vm.mymoney(row["subtotal"])
                                              ) +
                                              "\n                                            "
                                          )
                                        ]
                                      }
                                    }
                                  ])
                                }),
                                _vm._v(" "),
                                _c("table-column", {
                                  attrs: {
                                    sortable: false,
                                    filterable: false,
                                    label: "Acciones"
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "default",
                                      fn: function(row) {
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "table__actions" },
                                            [
                                              _c(
                                                "button",
                                                {
                                                  staticClass: "btn btn-danger",
                                                  on: {
                                                    click: function($event) {
                                                      _vm.removeProduct(
                                                        _vm.getIndex(
                                                          _vm.selectProducts,
                                                          row["id"]
                                                        )
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "icon-fa icon-fa-trash"
                                                  }),
                                                  _vm._v(
                                                    "\n                                                        Quitar\n                                                    "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      }
                                    }
                                  ])
                                }),
                                _vm._v(" "),
                                _c("template", { slot: "tfoot" }, [
                                  _c("tr", [
                                    _c(
                                      "th",
                                      {
                                        staticClass: "text-right",
                                        attrs: { colspan: "6" }
                                      },
                                      [
                                        _c(
                                          "h6",
                                          { staticClass: "font-weight-bold" },
                                          [_vm._v("Total")]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("th", [
                                      _c(
                                        "h6",
                                        { staticClass: "font-weight-bold" },
                                        [_vm._v(_vm._s(_vm.mymoney(_vm.total)))]
                                      )
                                    ])
                                  ])
                                ])
                              ],
                              2
                            )
                          ],
                          1
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-lg-6" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _c("label", [_vm._v("Comentario")]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.description,
                                expression: "description"
                              }
                            ],
                            ref: "description",
                            staticClass: "form-control",
                            attrs: { placeholder: "Comentario sobre la venta" },
                            domProps: { value: _vm.description },
                            on: {
                              keyup: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.changeRefVue("deliveryDate")
                              },
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.description = $event.target.value
                              }
                            }
                          })
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-lg-6" }, [
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c("label", [_vm._v("Fecha de entrega")]),
                            _vm._v(" "),
                            _c("datepicker", {
                              ref: "deliveryDate",
                              attrs: {
                                format: _vm.format,
                                "input-class": "form-control",
                                language: _vm.es
                              },
                              model: {
                                value: _vm.dateDelivery,
                                callback: function($$v) {
                                  _vm.dateDelivery = $$v
                                },
                                expression: "dateDelivery"
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("tab", { attrs: { id: "pagar", name: "Pagar" } }, [
                  _vm.selectProducts.length > 0
                    ? _c("div", [
                        _c("div", { staticClass: "card-body" }, [
                          _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              { staticClass: "col-lg-7" },
                              [
                                _c(
                                  "tabs",
                                  {
                                    staticClass: "tabs-default",
                                    attrs: {
                                      options: { defaultTabHash: "Efectivo" }
                                    }
                                  },
                                  [
                                    _c(
                                      "tab",
                                      {
                                        attrs: {
                                          name: "Efectivo",
                                          "is-disabled":
                                            _vm.payments[
                                              _vm.getIndexWithName(
                                                _vm.payments,
                                                "Efectivo"
                                              )
                                            ].status
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "card-body" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "form-group" },
                                              [
                                                _c("label", [_vm._v("Pagado")]),
                                                _vm._v(" "),
                                                _c("masked-input", {
                                                  ref: "efectivoInput",
                                                  staticClass: "form-control",
                                                  attrs: {
                                                    type: "text",
                                                    mask: _vm.mask_quetzal,
                                                    guide: false,
                                                    "keep-char-positions": true,
                                                    "show-mask": true
                                                  },
                                                  on: {
                                                    blur: function($event) {
                                                      return _vm.addAllTypesOfPayments()
                                                    }
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.payments[
                                                        _vm.getIndexWithName(
                                                          _vm.payments,
                                                          "Efectivo"
                                                        )
                                                      ].amountTurned,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.payments[
                                                          _vm.getIndexWithName(
                                                            _vm.payments,
                                                            "Efectivo"
                                                          )
                                                        ],
                                                        "amountTurned",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "payments[getIndexWithName(payments,'Efectivo')].amountTurned"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "form-group" },
                                              [
                                                _c("label", [_vm._v("Cambio")]),
                                                _vm._v(" "),
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.payments[
                                                          _vm.getIndexWithName(
                                                            _vm.payments,
                                                            "Efectivo"
                                                          )
                                                        ].amountPaid,
                                                      expression:
                                                        "payments[getIndexWithName(payments,'Efectivo')].amountPaid"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  attrs: {
                                                    type: "text",
                                                    readonly: "true"
                                                  },
                                                  domProps: {
                                                    value:
                                                      _vm.payments[
                                                        _vm.getIndexWithName(
                                                          _vm.payments,
                                                          "Efectivo"
                                                        )
                                                      ].amountPaid
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.$set(
                                                        _vm.payments[
                                                          _vm.getIndexWithName(
                                                            _vm.payments,
                                                            "Efectivo"
                                                          )
                                                        ],
                                                        "amountPaid",
                                                        $event.target.value
                                                      )
                                                    }
                                                  }
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "form-group" },
                                              [
                                                _c("label", [_vm._v("Cuenta")]),
                                                _vm._v(" "),
                                                _c(
                                                  "select",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.payments[
                                                            _vm.getIndexWithName(
                                                              _vm.payments,
                                                              "Efectivo"
                                                            )
                                                          ].account,
                                                        expression:
                                                          "payments[getIndexWithName(payments,'Efectivo')].account"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    on: {
                                                      change: function($event) {
                                                        var $$selectedVal = Array.prototype.filter
                                                          .call(
                                                            $event.target
                                                              .options,
                                                            function(o) {
                                                              return o.selected
                                                            }
                                                          )
                                                          .map(function(o) {
                                                            var val =
                                                              "_value" in o
                                                                ? o._value
                                                                : o.value
                                                            return val
                                                          })
                                                        _vm.$set(
                                                          _vm.payments[
                                                            _vm.getIndexWithName(
                                                              _vm.payments,
                                                              "Efectivo"
                                                            )
                                                          ],
                                                          "account",
                                                          $event.target.multiple
                                                            ? $$selectedVal
                                                            : $$selectedVal[0]
                                                        )
                                                      }
                                                    }
                                                  },
                                                  _vm._l(
                                                    _vm.payments[
                                                      _vm.getIndexWithName(
                                                        _vm.payments,
                                                        "Efectivo"
                                                      )
                                                    ].accounts,
                                                    function(item) {
                                                      return _c(
                                                        "option",
                                                        {
                                                          key: item.id,
                                                          domProps: {
                                                            value: item
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                                            " +
                                                              _vm._s(
                                                                item.name
                                                              ) +
                                                              " / " +
                                                              _vm._s(
                                                                _vm.mymoney(
                                                                  item.amount
                                                                )
                                                              )
                                                          )
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "form-group" },
                                              [
                                                _c("label", [
                                                  _vm._v("Descripción")
                                                ]),
                                                _vm._v(" "),
                                                _c("textarea", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.payments[
                                                          _vm.getIndexWithName(
                                                            _vm.payments,
                                                            "Efectivo"
                                                          )
                                                        ].description,
                                                      expression:
                                                        "payments[getIndexWithName(payments,'Efectivo')].description"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  attrs: { rows: "5" },
                                                  domProps: {
                                                    value:
                                                      _vm.payments[
                                                        _vm.getIndexWithName(
                                                          _vm.payments,
                                                          "Efectivo"
                                                        )
                                                      ].description
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.$set(
                                                        _vm.payments[
                                                          _vm.getIndexWithName(
                                                            _vm.payments,
                                                            "Efectivo"
                                                          )
                                                        ],
                                                        "description",
                                                        $event.target.value
                                                      )
                                                    }
                                                  }
                                                })
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "tab",
                                      {
                                        attrs: {
                                          name: "Cheque",
                                          "is-disabled":
                                            _vm.payments[
                                              _vm.getIndexWithName(
                                                _vm.payments,
                                                "Cheque"
                                              )
                                            ].status
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "card-body" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "form-group" },
                                              [
                                                _c("label", [
                                                  _vm._v("Cantidad")
                                                ]),
                                                _vm._v(" "),
                                                _c("masked-input", {
                                                  ref: "efectivoInput",
                                                  staticClass: "form-control",
                                                  attrs: {
                                                    type: "text",
                                                    mask: _vm.mask_quetzal,
                                                    guide: false,
                                                    "keep-char-positions": true,
                                                    "show-mask": true
                                                  },
                                                  on: {
                                                    blur: function($event) {
                                                      return _vm.addAllTypesOfPayments()
                                                    }
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.payments[
                                                        _vm.getIndexWithName(
                                                          _vm.payments,
                                                          "Cheque"
                                                        )
                                                      ].amount,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.payments[
                                                          _vm.getIndexWithName(
                                                            _vm.payments,
                                                            "Cheque"
                                                          )
                                                        ],
                                                        "amount",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "payments[getIndexWithName(payments,'Cheque')].amount"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "form-group" },
                                              [
                                                _c("label", [_vm._v("Cuenta")]),
                                                _vm._v(" "),
                                                _c(
                                                  "select",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.payments[
                                                            _vm.getIndexWithName(
                                                              _vm.payments,
                                                              "Cheque"
                                                            )
                                                          ].account,
                                                        expression:
                                                          "payments[getIndexWithName(payments,'Cheque')].account"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    on: {
                                                      change: function($event) {
                                                        var $$selectedVal = Array.prototype.filter
                                                          .call(
                                                            $event.target
                                                              .options,
                                                            function(o) {
                                                              return o.selected
                                                            }
                                                          )
                                                          .map(function(o) {
                                                            var val =
                                                              "_value" in o
                                                                ? o._value
                                                                : o.value
                                                            return val
                                                          })
                                                        _vm.$set(
                                                          _vm.payments[
                                                            _vm.getIndexWithName(
                                                              _vm.payments,
                                                              "Cheque"
                                                            )
                                                          ],
                                                          "account",
                                                          $event.target.multiple
                                                            ? $$selectedVal
                                                            : $$selectedVal[0]
                                                        )
                                                      }
                                                    }
                                                  },
                                                  _vm._l(
                                                    _vm.payments[
                                                      _vm.getIndexWithName(
                                                        _vm.payments,
                                                        "Cheque"
                                                      )
                                                    ].accounts,
                                                    function(item) {
                                                      return _c(
                                                        "option",
                                                        {
                                                          key: item.id,
                                                          domProps: {
                                                            value: item
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                                            " +
                                                              _vm._s(
                                                                item.name
                                                              ) +
                                                              " / " +
                                                              _vm._s(
                                                                _vm.mymoney(
                                                                  item.amount
                                                                )
                                                              )
                                                          )
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "form-group" },
                                              [
                                                _c("label", [
                                                  _vm._v("No.Cheque")
                                                ]),
                                                _vm._v(" "),
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.payments[
                                                          _vm.getIndexWithName(
                                                            _vm.payments,
                                                            "Cheque"
                                                          )
                                                        ].ChequeNumber,
                                                      expression:
                                                        "payments[getIndexWithName(payments,'Cheque')].ChequeNumber"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  attrs: { type: "text" },
                                                  domProps: {
                                                    value:
                                                      _vm.payments[
                                                        _vm.getIndexWithName(
                                                          _vm.payments,
                                                          "Cheque"
                                                        )
                                                      ].ChequeNumber
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.$set(
                                                        _vm.payments[
                                                          _vm.getIndexWithName(
                                                            _vm.payments,
                                                            "Cheque"
                                                          )
                                                        ],
                                                        "ChequeNumber",
                                                        $event.target.value
                                                      )
                                                    }
                                                  }
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("bank", {
                                              attrs: {
                                                item: _vm.getIndexWithName(
                                                  _vm.payments,
                                                  "Cheque"
                                                ),
                                                variable: "ChequeNameBank"
                                              },
                                              on: {
                                                "update-bank": _vm.updateBank
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "form-group" },
                                              [
                                                _c("label", [
                                                  _vm._v("Mismo banco")
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "select",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.payments[
                                                            _vm.getIndexWithName(
                                                              _vm.payments,
                                                              "Cheque"
                                                            )
                                                          ].ChequeSameBank,
                                                        expression:
                                                          "payments[getIndexWithName(payments,'Cheque')].ChequeSameBank"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    on: {
                                                      change: function($event) {
                                                        var $$selectedVal = Array.prototype.filter
                                                          .call(
                                                            $event.target
                                                              .options,
                                                            function(o) {
                                                              return o.selected
                                                            }
                                                          )
                                                          .map(function(o) {
                                                            var val =
                                                              "_value" in o
                                                                ? o._value
                                                                : o.value
                                                            return val
                                                          })
                                                        _vm.$set(
                                                          _vm.payments[
                                                            _vm.getIndexWithName(
                                                              _vm.payments,
                                                              "Cheque"
                                                            )
                                                          ],
                                                          "ChequeSameBank",
                                                          $event.target.multiple
                                                            ? $$selectedVal
                                                            : $$selectedVal[0]
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "option",
                                                      { attrs: { value: "1" } },
                                                      [_vm._v("Si")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "option",
                                                      { attrs: { value: "0" } },
                                                      [_vm._v("No")]
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "form-group" },
                                              [
                                                _c("label", [
                                                  _vm._v("Descripción")
                                                ]),
                                                _vm._v(" "),
                                                _c("textarea", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.payments[
                                                          _vm.getIndexWithName(
                                                            _vm.payments,
                                                            "Cheque"
                                                          )
                                                        ].description,
                                                      expression:
                                                        "payments[getIndexWithName(payments,'Cheque')].description"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  attrs: { rows: "5" },
                                                  domProps: {
                                                    value:
                                                      _vm.payments[
                                                        _vm.getIndexWithName(
                                                          _vm.payments,
                                                          "Cheque"
                                                        )
                                                      ].description
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.$set(
                                                        _vm.payments[
                                                          _vm.getIndexWithName(
                                                            _vm.payments,
                                                            "Cheque"
                                                          )
                                                        ],
                                                        "description",
                                                        $event.target.value
                                                      )
                                                    }
                                                  }
                                                })
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "tab",
                                      {
                                        attrs: {
                                          name: "Depósito",
                                          "is-disabled":
                                            _vm.payments[
                                              _vm.getIndexWithName(
                                                _vm.payments,
                                                "Depósito"
                                              )
                                            ].status
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "card-body" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "form-group" },
                                              [
                                                _c("label", [
                                                  _vm._v("Cantidad")
                                                ]),
                                                _vm._v(" "),
                                                _c("masked-input", {
                                                  ref: "efectivoInput",
                                                  staticClass: "form-control",
                                                  attrs: {
                                                    type: "text",
                                                    mask: _vm.mask_quetzal,
                                                    guide: false,
                                                    "keep-char-positions": true,
                                                    "show-mask": true
                                                  },
                                                  on: {
                                                    blur: function($event) {
                                                      return _vm.addAllTypesOfPayments()
                                                    }
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.payments[
                                                        _vm.getIndexWithName(
                                                          _vm.payments,
                                                          "Depósito"
                                                        )
                                                      ].amount,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.payments[
                                                          _vm.getIndexWithName(
                                                            _vm.payments,
                                                            "Depósito"
                                                          )
                                                        ],
                                                        "amount",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "payments[getIndexWithName(payments,'Depósito')].amount"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "form-group" },
                                              [
                                                _c("label", [_vm._v("Cuenta")]),
                                                _vm._v(" "),
                                                _c(
                                                  "select",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.payments[
                                                            _vm.getIndexWithName(
                                                              _vm.payments,
                                                              "Depósito"
                                                            )
                                                          ].account,
                                                        expression:
                                                          "payments[getIndexWithName(payments,'Depósito')].account"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    on: {
                                                      change: function($event) {
                                                        var $$selectedVal = Array.prototype.filter
                                                          .call(
                                                            $event.target
                                                              .options,
                                                            function(o) {
                                                              return o.selected
                                                            }
                                                          )
                                                          .map(function(o) {
                                                            var val =
                                                              "_value" in o
                                                                ? o._value
                                                                : o.value
                                                            return val
                                                          })
                                                        _vm.$set(
                                                          _vm.payments[
                                                            _vm.getIndexWithName(
                                                              _vm.payments,
                                                              "Depósito"
                                                            )
                                                          ],
                                                          "account",
                                                          $event.target.multiple
                                                            ? $$selectedVal
                                                            : $$selectedVal[0]
                                                        )
                                                      }
                                                    }
                                                  },
                                                  _vm._l(
                                                    _vm.payments[
                                                      _vm.getIndexWithName(
                                                        _vm.payments,
                                                        "Depósito"
                                                      )
                                                    ].accounts,
                                                    function(item) {
                                                      return _c(
                                                        "option",
                                                        {
                                                          key: item.id,
                                                          domProps: {
                                                            value: item
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                                            " +
                                                              _vm._s(
                                                                item.name
                                                              ) +
                                                              " / " +
                                                              _vm._s(
                                                                _vm.mymoney(
                                                                  item.amount
                                                                )
                                                              )
                                                          )
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "form-group" },
                                              [
                                                _c("label", [
                                                  _vm._v("No.Depósito")
                                                ]),
                                                _vm._v(" "),
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.payments[
                                                          _vm.getIndexWithName(
                                                            _vm.payments,
                                                            "Depósito"
                                                          )
                                                        ].DepositNumber,
                                                      expression:
                                                        "payments[getIndexWithName(payments,'Depósito')].DepositNumber"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  attrs: { type: "text" },
                                                  domProps: {
                                                    value:
                                                      _vm.payments[
                                                        _vm.getIndexWithName(
                                                          _vm.payments,
                                                          "Depósito"
                                                        )
                                                      ].DepositNumber
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.$set(
                                                        _vm.payments[
                                                          _vm.getIndexWithName(
                                                            _vm.payments,
                                                            "Depósito"
                                                          )
                                                        ],
                                                        "DepositNumber",
                                                        $event.target.value
                                                      )
                                                    }
                                                  }
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "form-group" },
                                              [
                                                _c("label", [
                                                  _vm._v("Descripción")
                                                ]),
                                                _vm._v(" "),
                                                _c("textarea", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.payments[
                                                          _vm.getIndexWithName(
                                                            _vm.payments,
                                                            "Depósito"
                                                          )
                                                        ].description,
                                                      expression:
                                                        "payments[getIndexWithName(payments,'Depósito')].description"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  attrs: { rows: "5" },
                                                  domProps: {
                                                    value:
                                                      _vm.payments[
                                                        _vm.getIndexWithName(
                                                          _vm.payments,
                                                          "Depósito"
                                                        )
                                                      ].description
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.$set(
                                                        _vm.payments[
                                                          _vm.getIndexWithName(
                                                            _vm.payments,
                                                            "Depósito"
                                                          )
                                                        ],
                                                        "description",
                                                        $event.target.value
                                                      )
                                                    }
                                                  }
                                                })
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "tab",
                                      {
                                        attrs: {
                                          name: "Tarjeta de Crédito/Debito",
                                          "is-disabled":
                                            _vm.payments[
                                              _vm.getIndexWithName(
                                                _vm.payments,
                                                "Transferencia"
                                              )
                                            ].status
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "card-body" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "form-group" },
                                              [
                                                _c("label", [
                                                  _vm._v("Cantidad")
                                                ]),
                                                _vm._v(" "),
                                                _c("masked-input", {
                                                  ref: "efectivoInput",
                                                  staticClass: "form-control",
                                                  attrs: {
                                                    type: "text",
                                                    mask: _vm.mask_quetzal,
                                                    guide: false,
                                                    "keep-char-positions": true,
                                                    "show-mask": true
                                                  },
                                                  on: {
                                                    blur: function($event) {
                                                      return _vm.addAllTypesOfPayments()
                                                    }
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.payments[
                                                        _vm.getIndexWithName(
                                                          _vm.payments,
                                                          "Tarjeta de Crédito/Debito"
                                                        )
                                                      ].amount,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.payments[
                                                          _vm.getIndexWithName(
                                                            _vm.payments,
                                                            "Tarjeta de Crédito/Debito"
                                                          )
                                                        ],
                                                        "amount",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "payments[getIndexWithName(payments,'Tarjeta de Crédito/Debito')].amount"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "form-group" },
                                              [
                                                _c("label", [_vm._v("Cuenta")]),
                                                _vm._v(" "),
                                                _c(
                                                  "select",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.payments[
                                                            _vm.getIndexWithName(
                                                              _vm.payments,
                                                              "Tarjeta de Crédito/Debito"
                                                            )
                                                          ].account,
                                                        expression:
                                                          "payments[getIndexWithName(payments,'Tarjeta de Crédito/Debito')].account"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    on: {
                                                      change: function($event) {
                                                        var $$selectedVal = Array.prototype.filter
                                                          .call(
                                                            $event.target
                                                              .options,
                                                            function(o) {
                                                              return o.selected
                                                            }
                                                          )
                                                          .map(function(o) {
                                                            var val =
                                                              "_value" in o
                                                                ? o._value
                                                                : o.value
                                                            return val
                                                          })
                                                        _vm.$set(
                                                          _vm.payments[
                                                            _vm.getIndexWithName(
                                                              _vm.payments,
                                                              "Tarjeta de Crédito/Debito"
                                                            )
                                                          ],
                                                          "account",
                                                          $event.target.multiple
                                                            ? $$selectedVal
                                                            : $$selectedVal[0]
                                                        )
                                                      }
                                                    }
                                                  },
                                                  _vm._l(
                                                    _vm.payments[
                                                      _vm.getIndexWithName(
                                                        _vm.payments,
                                                        "Tarjeta de Crédito/Debito"
                                                      )
                                                    ].accounts,
                                                    function(item) {
                                                      return _c(
                                                        "option",
                                                        {
                                                          key: item.id,
                                                          domProps: {
                                                            value: item
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                                            " +
                                                              _vm._s(
                                                                item.name
                                                              ) +
                                                              " / " +
                                                              _vm._s(
                                                                _vm.mymoney(
                                                                  item.amount
                                                                )
                                                              )
                                                          )
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "form-group" },
                                              [
                                                _c("label", [
                                                  _vm._v("No.Transacción")
                                                ]),
                                                _vm._v(" "),
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.payments[
                                                          _vm.getIndexWithName(
                                                            _vm.payments,
                                                            "Tarjeta de Crédito/Debito"
                                                          )
                                                        ].CardNumber,
                                                      expression:
                                                        "payments[getIndexWithName(payments,'Tarjeta de Crédito/Debito')].CardNumber"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  attrs: { type: "text" },
                                                  domProps: {
                                                    value:
                                                      _vm.payments[
                                                        _vm.getIndexWithName(
                                                          _vm.payments,
                                                          "Tarjeta de Crédito/Debito"
                                                        )
                                                      ].CardNumber
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.$set(
                                                        _vm.payments[
                                                          _vm.getIndexWithName(
                                                            _vm.payments,
                                                            "Tarjeta de Crédito/Debito"
                                                          )
                                                        ],
                                                        "CardNumber",
                                                        $event.target.value
                                                      )
                                                    }
                                                  }
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "form-group" },
                                              [
                                                _c("label", [
                                                  _vm._v("Nombre de tarjeta")
                                                ]),
                                                _vm._v(" "),
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.payments[
                                                          _vm.getIndexWithName(
                                                            _vm.payments,
                                                            "Tarjeta de Crédito/Debito"
                                                          )
                                                        ].CardName,
                                                      expression:
                                                        "payments[getIndexWithName(payments,'Tarjeta de Crédito/Debito')].CardName"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  attrs: { type: "text" },
                                                  domProps: {
                                                    value:
                                                      _vm.payments[
                                                        _vm.getIndexWithName(
                                                          _vm.payments,
                                                          "Tarjeta de Crédito/Debito"
                                                        )
                                                      ].CardName
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.$set(
                                                        _vm.payments[
                                                          _vm.getIndexWithName(
                                                            _vm.payments,
                                                            "Tarjeta de Crédito/Debito"
                                                          )
                                                        ],
                                                        "CardName",
                                                        $event.target.value
                                                      )
                                                    }
                                                  }
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "form-group" },
                                              [
                                                _c("label", [
                                                  _vm._v(
                                                    "Ultimos 4 dígitos de la tarjeta"
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.payments[
                                                          _vm.getIndexWithName(
                                                            _vm.payments,
                                                            "Tarjeta de Crédito/Debito"
                                                          )
                                                        ].CardLast4digits,
                                                      expression:
                                                        "payments[getIndexWithName(payments,'Tarjeta de Crédito/Debito')].CardLast4digits"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  attrs: { type: "text" },
                                                  domProps: {
                                                    value:
                                                      _vm.payments[
                                                        _vm.getIndexWithName(
                                                          _vm.payments,
                                                          "Tarjeta de Crédito/Debito"
                                                        )
                                                      ].CardLast4digits
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.$set(
                                                        _vm.payments[
                                                          _vm.getIndexWithName(
                                                            _vm.payments,
                                                            "Tarjeta de Crédito/Debito"
                                                          )
                                                        ],
                                                        "CardLast4digits",
                                                        $event.target.value
                                                      )
                                                    }
                                                  }
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "form-group" },
                                              [
                                                _c("label", [
                                                  _vm._v("Descripción")
                                                ]),
                                                _vm._v(" "),
                                                _c("textarea", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.payments[
                                                          _vm.getIndexWithName(
                                                            _vm.payments,
                                                            "Tarjeta de Crédito/Debito"
                                                          )
                                                        ].description,
                                                      expression:
                                                        "payments[getIndexWithName(payments,'Tarjeta de Crédito/Debito')].description"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  attrs: { rows: "5" },
                                                  domProps: {
                                                    value:
                                                      _vm.payments[
                                                        _vm.getIndexWithName(
                                                          _vm.payments,
                                                          "Tarjeta de Crédito/Debito"
                                                        )
                                                      ].description
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.$set(
                                                        _vm.payments[
                                                          _vm.getIndexWithName(
                                                            _vm.payments,
                                                            "Tarjeta de Crédito/Debito"
                                                          )
                                                        ],
                                                        "description",
                                                        $event.target.value
                                                      )
                                                    }
                                                  }
                                                })
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "tab",
                                      {
                                        attrs: {
                                          name: "Transferencia",
                                          "is-disabled":
                                            _vm.payments[
                                              _vm.getIndexWithName(
                                                _vm.payments,
                                                "Transferencia"
                                              )
                                            ].status
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "card-body" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "form-group" },
                                              [
                                                _c("label", [
                                                  _vm._v("Cantidad")
                                                ]),
                                                _vm._v(" "),
                                                _c("masked-input", {
                                                  ref: "efectivoInput",
                                                  staticClass: "form-control",
                                                  attrs: {
                                                    type: "text",
                                                    mask: _vm.mask_quetzal,
                                                    guide: false,
                                                    "keep-char-positions": true,
                                                    "show-mask": true
                                                  },
                                                  on: {
                                                    blur: function($event) {
                                                      return _vm.addAllTypesOfPayments()
                                                    }
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.payments[
                                                        _vm.getIndexWithName(
                                                          _vm.payments,
                                                          "Transferencia"
                                                        )
                                                      ].amount,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.payments[
                                                          _vm.getIndexWithName(
                                                            _vm.payments,
                                                            "Transferencia"
                                                          )
                                                        ],
                                                        "amount",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "payments[getIndexWithName(payments,'Transferencia')].amount"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "form-group" },
                                              [
                                                _c("label", [_vm._v("Cuenta")]),
                                                _vm._v(" "),
                                                _c(
                                                  "select",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.payments[
                                                            _vm.getIndexWithName(
                                                              _vm.payments,
                                                              "Transferencia"
                                                            )
                                                          ].account,
                                                        expression:
                                                          "payments[getIndexWithName(payments,'Transferencia')].account"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    on: {
                                                      change: function($event) {
                                                        var $$selectedVal = Array.prototype.filter
                                                          .call(
                                                            $event.target
                                                              .options,
                                                            function(o) {
                                                              return o.selected
                                                            }
                                                          )
                                                          .map(function(o) {
                                                            var val =
                                                              "_value" in o
                                                                ? o._value
                                                                : o.value
                                                            return val
                                                          })
                                                        _vm.$set(
                                                          _vm.payments[
                                                            _vm.getIndexWithName(
                                                              _vm.payments,
                                                              "Transferencia"
                                                            )
                                                          ],
                                                          "account",
                                                          $event.target.multiple
                                                            ? $$selectedVal
                                                            : $$selectedVal[0]
                                                        )
                                                      }
                                                    }
                                                  },
                                                  _vm._l(
                                                    _vm.payments[
                                                      _vm.getIndexWithName(
                                                        _vm.payments,
                                                        "Transferencia"
                                                      )
                                                    ].accounts,
                                                    function(item) {
                                                      return _c(
                                                        "option",
                                                        {
                                                          key: item.id,
                                                          domProps: {
                                                            value: item
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                                            " +
                                                              _vm._s(
                                                                item.name
                                                              ) +
                                                              " / " +
                                                              _vm._s(
                                                                _vm.mymoney(
                                                                  item.amount
                                                                )
                                                              )
                                                          )
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "form-group" },
                                              [
                                                _c("label", [
                                                  _vm._v("No.Transferencia")
                                                ]),
                                                _vm._v(" "),
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.payments[
                                                          _vm.getIndexWithName(
                                                            _vm.payments,
                                                            "Transferencia"
                                                          )
                                                        ].TransferNumber,
                                                      expression:
                                                        "payments[getIndexWithName(payments,'Transferencia')].TransferNumber"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  attrs: { type: "text" },
                                                  domProps: {
                                                    value:
                                                      _vm.payments[
                                                        _vm.getIndexWithName(
                                                          _vm.payments,
                                                          "Transferencia"
                                                        )
                                                      ].TransferNumber
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.$set(
                                                        _vm.payments[
                                                          _vm.getIndexWithName(
                                                            _vm.payments,
                                                            "Transferencia"
                                                          )
                                                        ],
                                                        "TransferNumber",
                                                        $event.target.value
                                                      )
                                                    }
                                                  }
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("bank", {
                                              attrs: {
                                                item: _vm.getIndexWithName(
                                                  _vm.payments,
                                                  "Transferencia"
                                                ),
                                                variable: "TransferNameBank"
                                              },
                                              on: {
                                                "update-bank": _vm.updateBank
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "form-group" },
                                              [
                                                _c("label", [
                                                  _vm._v("Mismo banco")
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "select",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.payments[
                                                            _vm.getIndexWithName(
                                                              _vm.payments,
                                                              "Transferencia"
                                                            )
                                                          ].TransferSameBank,
                                                        expression:
                                                          "payments[getIndexWithName(payments,'Transferencia')].TransferSameBank"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    on: {
                                                      change: function($event) {
                                                        var $$selectedVal = Array.prototype.filter
                                                          .call(
                                                            $event.target
                                                              .options,
                                                            function(o) {
                                                              return o.selected
                                                            }
                                                          )
                                                          .map(function(o) {
                                                            var val =
                                                              "_value" in o
                                                                ? o._value
                                                                : o.value
                                                            return val
                                                          })
                                                        _vm.$set(
                                                          _vm.payments[
                                                            _vm.getIndexWithName(
                                                              _vm.payments,
                                                              "Transferencia"
                                                            )
                                                          ],
                                                          "TransferSameBank",
                                                          $event.target.multiple
                                                            ? $$selectedVal
                                                            : $$selectedVal[0]
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "option",
                                                      { attrs: { value: "1" } },
                                                      [_vm._v("Si")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "option",
                                                      { attrs: { value: "0" } },
                                                      [_vm._v("No")]
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "form-group" },
                                              [
                                                _c("label", [
                                                  _vm._v("Descripción")
                                                ]),
                                                _vm._v(" "),
                                                _c("textarea", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.payments[
                                                          _vm.getIndexWithName(
                                                            _vm.payments,
                                                            "Transferencia"
                                                          )
                                                        ].description,
                                                      expression:
                                                        "payments[getIndexWithName(payments,'Transferencia')].description"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  attrs: { rows: "5" },
                                                  domProps: {
                                                    value:
                                                      _vm.payments[
                                                        _vm.getIndexWithName(
                                                          _vm.payments,
                                                          "Transferencia"
                                                        )
                                                      ].description
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.$set(
                                                        _vm.payments[
                                                          _vm.getIndexWithName(
                                                            _vm.payments,
                                                            "Transferencia"
                                                          )
                                                        ],
                                                        "description",
                                                        $event.target.value
                                                      )
                                                    }
                                                  }
                                                })
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "tab",
                                      {
                                        attrs: {
                                          name: "Crédito",
                                          "is-disabled":
                                            _vm.payments[
                                              _vm.getIndexWithName(
                                                _vm.payments,
                                                "Crédito"
                                              )
                                            ].status || _vm.typePaymentCredit()
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "card-body" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "form-group" },
                                              [
                                                _c("label", [
                                                  _vm._v("Cantidad")
                                                ]),
                                                _vm._v(" "),
                                                _c("masked-input", {
                                                  ref: "efectivoInput",
                                                  staticClass: "form-control",
                                                  attrs: {
                                                    type: "text",
                                                    mask: _vm.mask_quetzal,
                                                    guide: false,
                                                    "keep-char-positions": true,
                                                    "show-mask": true
                                                  },
                                                  on: {
                                                    blur: function($event) {
                                                      return _vm.addAllTypesOfPayments()
                                                    }
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.payments[
                                                        _vm.getIndexWithName(
                                                          _vm.payments,
                                                          "Crédito"
                                                        )
                                                      ].amount,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.payments[
                                                          _vm.getIndexWithName(
                                                            _vm.payments,
                                                            "Crédito"
                                                          )
                                                        ],
                                                        "amount",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "payments[getIndexWithName(payments,'Crédito')].amount"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "form-group" },
                                              [
                                                _c("label", [_vm._v("Cuenta")]),
                                                _vm._v(" "),
                                                _c(
                                                  "select",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.payments[
                                                            _vm.getIndexWithName(
                                                              _vm.payments,
                                                              "Crédito"
                                                            )
                                                          ].account,
                                                        expression:
                                                          "payments[getIndexWithName(payments,'Crédito')].account"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    on: {
                                                      change: function($event) {
                                                        var $$selectedVal = Array.prototype.filter
                                                          .call(
                                                            $event.target
                                                              .options,
                                                            function(o) {
                                                              return o.selected
                                                            }
                                                          )
                                                          .map(function(o) {
                                                            var val =
                                                              "_value" in o
                                                                ? o._value
                                                                : o.value
                                                            return val
                                                          })
                                                        _vm.$set(
                                                          _vm.payments[
                                                            _vm.getIndexWithName(
                                                              _vm.payments,
                                                              "Crédito"
                                                            )
                                                          ],
                                                          "account",
                                                          $event.target.multiple
                                                            ? $$selectedVal
                                                            : $$selectedVal[0]
                                                        )
                                                      }
                                                    }
                                                  },
                                                  _vm._l(
                                                    _vm.payments[
                                                      _vm.getIndexWithName(
                                                        _vm.payments,
                                                        "Crédito"
                                                      )
                                                    ].accounts,
                                                    function(item) {
                                                      return _c(
                                                        "option",
                                                        {
                                                          key: item.id,
                                                          domProps: {
                                                            value: item
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                                            " +
                                                              _vm._s(
                                                                item.name
                                                              ) +
                                                              " / " +
                                                              _vm._s(
                                                                _vm.mymoney(
                                                                  item.amount
                                                                )
                                                              )
                                                          )
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "form-group" },
                                              [
                                                _c("label", [
                                                  _vm._v("Fecha de cobro")
                                                ]),
                                                _vm._v(" "),
                                                _c("datepicker", {
                                                  attrs: {
                                                    format: _vm.format,
                                                    "input-class":
                                                      "form-control",
                                                    "disabled-dates":
                                                      _vm.highlighted,
                                                    language: _vm.es
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.payments[
                                                        _vm.getIndexWithName(
                                                          _vm.payments,
                                                          "Crédito"
                                                        )
                                                      ].CreditDateLimit,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.payments[
                                                          _vm.getIndexWithName(
                                                            _vm.payments,
                                                            "Crédito"
                                                          )
                                                        ],
                                                        "CreditDateLimit",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "payments[getIndexWithName(payments,'Crédito')].CreditDateLimit"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "form-group" },
                                              [
                                                _c("label", [
                                                  _vm._v("Descripción")
                                                ]),
                                                _vm._v(" "),
                                                _c("textarea", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.payments[
                                                          _vm.getIndexWithName(
                                                            _vm.payments,
                                                            "Crédito"
                                                          )
                                                        ].description,
                                                      expression:
                                                        "payments[getIndexWithName(payments,'Crédito')].description"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  attrs: { rows: "5" },
                                                  domProps: {
                                                    value:
                                                      _vm.payments[
                                                        _vm.getIndexWithName(
                                                          _vm.payments,
                                                          "Crédito"
                                                        )
                                                      ].description
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.$set(
                                                        _vm.payments[
                                                          _vm.getIndexWithName(
                                                            _vm.payments,
                                                            "Crédito"
                                                          )
                                                        ],
                                                        "description",
                                                        $event.target.value
                                                      )
                                                    }
                                                  }
                                                })
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-lg-5" }, [
                              _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "container" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "row justify-content-center"
                                    },
                                    [_c("h6", [_vm._v("Proveedor")])]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("table", [
                                  _c("tbody", [
                                    _c("tr", [
                                      _c(
                                        "td",
                                        { staticClass: "font-weight-bold" },
                                        [_vm._v("Proveedor: ")]
                                      ),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            typeof _vm.provider.company !==
                                              "undefined"
                                              ? _vm.provider.company
                                              : "Seleccione un proveedor"
                                          )
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("tr", [
                                      _c(
                                        "td",
                                        { staticClass: "font-weight-bold" },
                                        [_vm._v("Crédito autorizado: ")]
                                      ),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.mymoney(
                                              typeof _vm.provider
                                                .credit_limit !== "undefined"
                                                ? _vm.provider.credit_limit
                                                : 0
                                            )
                                          )
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("tr", [
                                      _c(
                                        "td",
                                        { staticClass: "font-weight-bold" },
                                        [_vm._v("Límete de días: ")]
                                      ),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            typeof _vm.provider.day_limit !==
                                              "undefined"
                                              ? _vm.provider.day_limit
                                              : "No aplica"
                                          )
                                        )
                                      ])
                                    ])
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "container" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "row justify-content-center"
                                    },
                                    [_c("h6", [_vm._v("Pagos")])]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("table", { staticClass: "table" }, [
                                  _c("thead", [
                                    _c("tr", [
                                      _c("th", [_vm._v("Tipo de pago")]),
                                      _vm._v(" "),
                                      _c("th", [_vm._v("Cantidad")]),
                                      _vm._v(" "),
                                      _c("th", [_vm._v("Cuenta")])
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "tbody",
                                    _vm._l(_vm.paymentWithAmount, function(
                                      payment
                                    ) {
                                      return _c("tr", { key: payment.id }, [
                                        _c("td", [
                                          _vm._v(_vm._s(payment.name))
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(_vm._s(payment.amount))
                                        ]),
                                        _vm._v(" "),
                                        payment.account != 0
                                          ? _c("td", [
                                              _vm._v(
                                                _vm._s(payment.account.name)
                                              )
                                            ])
                                          : _vm._e()
                                      ])
                                    }),
                                    0
                                  ),
                                  _vm._v(" "),
                                  _c("tfoot", [
                                    _c("tr", [
                                      _c(
                                        "td",
                                        { staticClass: "font-weight-bold" },
                                        [_vm._v("Monto total")]
                                      ),
                                      _vm._v(" "),
                                      _c("td", { attrs: { colspan: "2" } }, [
                                        _vm._v(
                                          _vm._s(_vm.mymoney(_vm.totalChequer))
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("tr", [
                                      _c(
                                        "td",
                                        { staticClass: "font-weight-bold" },
                                        [_vm._v("Total de la venta")]
                                      ),
                                      _vm._v(" "),
                                      _c("td", { attrs: { colspan: "2" } }, [
                                        _vm._v(_vm._s(_vm.mymoney(_vm.total)))
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("tr", [
                                      _c(
                                        "td",
                                        {
                                          staticClass: "font-weight-bold",
                                          class:
                                            _vm.subtraction(
                                              _vm.total,
                                              _vm.totalChequer
                                            ) === 0
                                              ? "bg-success"
                                              : "bg-danger"
                                        },
                                        [
                                          _vm._v(
                                            "\n                                                        Pendiente"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          class:
                                            _vm.subtraction(
                                              _vm.total,
                                              _vm.totalChequer
                                            ) === 0
                                              ? "bg-success"
                                              : "bg-danger",
                                          attrs: { colspan: "2" }
                                        },
                                        [
                                          _vm._v(
                                            "\n                                                        " +
                                              _vm._s(
                                                _vm.mymoney(
                                                  _vm.subtraction(
                                                    _vm.total,
                                                    _vm.totalChequer
                                                  )
                                                )
                                              )
                                          )
                                        ]
                                      )
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-lg-12" }, [
                              _c("div", { staticClass: "form-group" }, [
                                _c("label", [_vm._v(" ")]),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    ref: "buttonSave",
                                    staticClass:
                                      "btn btn-block btn-theme ladda-button",
                                    attrs: {
                                      slot: "button",
                                      "data-style": "expand-right"
                                    },
                                    on: {
                                      keyup: function($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        ) {
                                          return null
                                        }
                                        return _vm.saveAll.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                      click: _vm.saveAll
                                    },
                                    slot: "button"
                                  },
                                  [_vm._v("Guardar compra")]
                                )
                              ])
                            ])
                          ])
                        ])
                      ])
                    : _c("div", { staticClass: "card-body" }, [
                        _c("h1", { staticClass: "text-justify" }, [
                          _vm._v("No hay productos que pagar")
                        ])
                      ])
                ])
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "sweet-modal",
        {
          ref: "modal_provider",
          attrs: {
            title: "Nuevo proveedor",
            "hide-close-button": "",
            blocking: ""
          },
          on: { close: _vm.closeModalProvider }
        },
        [
          _c("div", { staticClass: "card-body" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("label", [_vm._v("Nit del proveedor")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _vm.providerNit,
                    expression: "providerNit",
                    modifiers: { trim: true }
                  }
                ],
                staticClass: "form-control",
                class: { "is-invalid": _vm.$v.providerNit.$error },
                attrs: { placeholder: "C/F" },
                domProps: { value: _vm.providerNit },
                on: {
                  blur: [
                    function($event) {
                      return _vm.$v.providerNit.$touch()
                    },
                    function($event) {
                      return _vm.$forceUpdate()
                    }
                  ],
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.providerNit = $event.target.value.trim()
                  }
                }
              }),
              _vm._v(" "),
              _vm.$v.providerNit.$error
                ? _c("div", [
                    !_vm.$v.providerNit.nit
                      ? _c(
                          "span",
                          { staticClass: "help-block help-block-error" },
                          [
                            _vm._v(
                              "El número de nit no es\n                        válido."
                            )
                          ]
                        )
                      : _vm._e()
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c("label", [_vm._v("Nombre contacto")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _vm.providerName,
                    expression: "providerName",
                    modifiers: { trim: true }
                  }
                ],
                staticClass: "form-control",
                domProps: { value: _vm.providerName },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.providerName = $event.target.value.trim()
                  },
                  blur: function($event) {
                    return _vm.$forceUpdate()
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c("label", [_vm._v("Empresa")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _vm.providerCompany,
                    expression: "providerCompany",
                    modifiers: { trim: true }
                  }
                ],
                staticClass: "form-control",
                class: { "is-invalid": _vm.$v.providerCompany.$error },
                domProps: { value: _vm.providerCompany },
                on: {
                  blur: [
                    function($event) {
                      return _vm.$v.providerCompany.$touch()
                    },
                    function($event) {
                      return _vm.$forceUpdate()
                    }
                  ],
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.providerCompany = $event.target.value.trim()
                  }
                }
              }),
              _vm._v(" "),
              _vm.$v.providerCompany.$error
                ? _c("div", [
                    !_vm.$v.providerCompany.required
                      ? _c(
                          "span",
                          { staticClass: "help-block help-block-error" },
                          [
                            _vm._v(
                              "El nombre de la\n                        empresa es requerida."
                            )
                          ]
                        )
                      : _vm._e()
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c("label", [_vm._v("Dirección")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _vm.providerAddress,
                    expression: "providerAddress",
                    modifiers: { trim: true }
                  }
                ],
                staticClass: "form-control",
                attrs: { placeholder: "Ciudad" },
                domProps: { value: _vm.providerAddress },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.providerAddress = $event.target.value.trim()
                  },
                  blur: function($event) {
                    return _vm.$forceUpdate()
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c("label", [_vm._v("Teléfono")]),
                _vm._v(" "),
                _c("masked-input", {
                  staticClass: "form-control",
                  attrs: {
                    mask: [/\d/, /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/],
                    guide: false,
                    "keep-char-positions": true,
                    "show-mask": true
                  },
                  model: {
                    value: _vm.providerTelephone,
                    callback: function($$v) {
                      _vm.providerTelephone = $$v
                    },
                    expression: "providerTelephone"
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-danger",
              attrs: { slot: "button", type: "button" },
              on: {
                click: function($event) {
                  return _vm.$refs.modal_provider.close()
                }
              },
              slot: "button"
            },
            [_vm._v("Cancelar")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-primary ladda-button",
              attrs: {
                slot: "button",
                type: "button",
                "data-style": "expand-right"
              },
              on: { click: _vm.saveProvider },
              slot: "button"
            },
            [_vm._v("Guardar")]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header" }, [
      _c("h3", { staticClass: "page-title" }, [_vm._v("Nueva compra")]),
      _vm._v(" "),
      _c("ol", { staticClass: "breadcrumb" }, [
        _c("li", { staticClass: "breadcrumb-item" }, [
          _c("a", { attrs: { href: "#" } }, [_vm._v("Compras")])
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "breadcrumb-item active" }, [
          _vm._v("Nueva compra")
        ])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-37f09b00", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37f09b00","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/views/admin/purchase/Purchase.vue
// module id = 699
// module chunks = 0